<mat-form-field appearance="fill">
    <mat-label>{{ label }}</mat-label>
    <mat-select [(ngModel)]="value" (selectionChange)="filter()">
        <mat-option>-</mat-option>
        <mat-option *ngFor="let item of items" [value]="item[itemValueProperty]">
            {{ item[itemLabelProperty] }}
        </mat-option>
    </mat-select>
</mat-form-field>
